import { createFeatureSelector, createSelector } from '@ngrx/store';

import { featureKey, notificationsAdapter, NotificationsEntityState } from './notifications.reducer';

const { selectAll, selectEntities, selectIds } = notificationsAdapter.getSelectors();

const selectNotificationsState = createFeatureSelector<NotificationsEntityState>(featureKey);

export const selectNotificationsList = createSelector(selectNotificationsState, (state) => selectAll(state));
export const selectNotificationsMap = createSelector(selectNotificationsState, (state) => selectEntities(state));
export const selectNotificationsIds = createSelector(selectNotificationsState, (state) => selectIds(state));
export const selectLoading = createSelector(selectNotificationsState, (state) => state.loading);
export const selectLoaded = createSelector(selectNotificationsState, (state) => state.loaded);
export const selectPageParams = createSelector(selectNotificationsState, (state) => state.pageParams);
export const selectLoadError = createSelector(selectNotificationsState, (state) => state.loadError);
export const selectTotalElements = createSelector(selectNotificationsState, (state) => state.totalElements);
export const selectNotificationIdsInProgress = createSelector(
    selectNotificationsState,
    (state) => state.notificationIdsInProgress
);
export const selectUnreadCount = createSelector(selectNotificationsState, (state) => state.unreadCount);
export const selectUnreadCountLoading = createSelector(selectNotificationsState, (state) => state.unreadCountLoading);
